<template>
  <v-expansion-panels class="mt-5" v-model="panel">
    <v-expansion-panel>
      <v-expansion-panel-header class="px-5 py-8">
        <v-row no-gutters align="center">
          <v-col class="pa-0">
            <span class="subtitle-2 grey-700--text font-weight-bold d-flex align-center">
              <v-icon class="mr-2" size="18" color="grey-700">mdi-earth</v-icon>Detalle tipo de cambio
              <v-chip v-if="!isExport" class="ml-3 pa-2 caption grey-700--text" x-small color="grey-background">Opcional</v-chip>
            </span>
          </v-col>
        </v-row>
      </v-expansion-panel-header>
      <v-expansion-panel-content class="px-0 pb-5">
        <v-row class="mt-n2" no-gutters>
          <v-col cols="12" class="py-0 px-5">
            <v-list class="transparent pa-0">
              <v-row no-gutters>
                <v-col cols="3" class="pa-0 mr-5">
                  <v-list-item class="pa-0">
                    <v-list-item-content>
                      <v-list-item-title class="grey-500--text py-1">Tipo de moneda</v-list-item-title>
                      <v-list-item-subtitle>
                        <v-autocomplete v-if="isExport" v-model.trim="v.exchange.currency_from.$model" :error="v.exchange.currency_from.$error" :items="currencies" :menu-props="{ overflowY: true, transition: 'slide-y-transition' }" item-value="code" item-text="name" height="40" single-line outlined dense hide-details no-data-text="No existen monedas disponibles." append-icon="mdi-chevron-down" placeholder="Selecciona el tipo de moneda">
                          <template v-slot:item="data">
                            <v-list-item-title class="font-weight-regular">{{data.item.code}} - {{data.item.name}}</v-list-item-title>
                          </template>
                        </v-autocomplete>
                        <v-autocomplete v-else v-model.trim="exchange.currency_from" :items="currencies" :menu-props="{ overflowY: true, transition: 'slide-y-transition' }" item-value="code" item-text="name" height="40" single-line outlined dense hide-details no-data-text="No existen monedas disponibles." append-icon="mdi-chevron-down" placeholder="Selecciona el tipo de moneda">
                          <template v-slot:item="data">
                            <v-list-item-title class="font-weight-regular">{{data.item.code}} - {{data.item.name}}</v-list-item-title>
                          </template>
                        </v-autocomplete>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="2" class="pa-0" v-if="$store.getters['base/currentCountry'] === 'CL'">
                  <v-list-item class="pa-0">
                    <v-list-item-content>
                      <v-list-item-title class="grey-500--text py-1">Tipo de cambio</v-list-item-title>
                      <v-list-item-subtitle>
                        <v-text-field v-if="isExport" v-model.number="v.exchange.rate.$model" :error="v.exchange.rate.$error" oninput="this.value=this.value.replace(/[^0-9.]/g,'');" suffix="CLP" required maxlength="12" single-line outlined flat dense hide-details />
                        <v-text-field v-else v-model.number="exchange.rate" oninput="this.value=this.value.replace(/[^0-9.]/g,'');" suffix="CLP" maxlength="12" single-line outlined flat dense hide-details />
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
              </v-row>
            </v-list>
          </v-col>
        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { EXPORT_TYPES } from '@/collections/documentTypeGroups'

export default {
  name: 'DocumentExchangeRatePanel',
  props: {
    // open panel index (v-model). No default, so the "collapsed" state (undefined) is not overridden.
    value: { type: Number },
    // parent's $v (vuelidate) object; used by reference to validate exchange on export documents
    v: { type: Object, required: true },
    // parent's exchange object (mutated directly in the non-export case)
    exchange: { type: Object, required: true },
    currencies: { type: Array, default: () => [] },
    documentType: { type: String, default: '' }
  },
  computed: {
    isExport () {
      return EXPORT_TYPES.includes(this.documentType)
    },
    panel: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
